var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23.03 26.19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e1dfba;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.18,0H.85A.85.85,0,0,0,0,.94L2,22.77a1.47,1.47,0,0,0,1,1.18l7.68,2.13a4.05,4.05,0,0,0,1.8,0L20.1,24a1.47,1.47,0,0,0,1-1.18L23,.94A.85.85,0,0,0,22.18,0Zm-3.7,7.88h0l-6,2.47a.18.18,0,0,0-.12.21.2.2,0,0,0,.19.16H17.2a.88.88,0,0,1,.65.29.85.85,0,0,1,.22.68l-.73,6.86a.86.86,0,0,1-.58.73L11.8,21a.83.83,0,0,1-.58,0l-5-1.71a.87.87,0,0,1-.58-.74l-.33-3.1A.56.56,0,0,1,5.5,15a.59.59,0,0,1,.43-.19H7.31a.57.57,0,0,1,.57.51l.2,1.91,3.43,1.19L15,17.25l.42-4H5.64a.57.57,0,0,1-.57-.51L4.89,11.1a.57.57,0,0,1,.35-.6l6.22-2.56a.17.17,0,0,0,.1-.18.16.16,0,0,0-.16-.13H4.85a.38.38,0,0,1-.38-.34L4.28,5.48a.37.37,0,0,1,.38-.42H18.37a.4.4,0,0,1,.29.12.43.43,0,0,1,.09.3Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss);
export default __webpack_public_path__ + "static/media/css.1b855f73a3f8e7c5e682039ad06891d0.svg";
export { ForwardRef as ReactComponent };